import React from "react";
import "../style/SessionExpiredModal.css";

const SessionExpiredModal = ({
  open,
  onLogin,
}) => {

  if (!open) return null;

  return (
    <div className="session-overlay">

      <div className="session-modal">

        <h2 className="session-title">
          Session Expired
        </h2>

        <p className="session-text">
          You were signed out automatically
          for security reasons.
          Please login again to continue.
        </p>

        <button
          onClick={onLogin}
          className="session-button"
        >
          Login Again
        </button>

      </div>

    </div>
  );
};

export default SessionExpiredModal;